<template>
    <input
        v-bind="$attrs"
        v-on="inputListeners"
        :id="'jix-range-vue--'+componentCounter"
        type="range"
        :value="modelValue"
        :min="min"
        :max="max"
    >
</template>

<script>
/**
 * A counter that is incremented for each instantiated component instance used
 * to generated a unique id.
 */
let counter = 1;

export default {
    emits: ['update:modelValue'],
    props: {
        min: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        modelValue: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            styleElem: null,
            style: null,
            componentCounter: counter++,
        };
    },
    computed: {
        inputListeners() {
            const handler = (event) => this.$emit('update:modelValue', Number(event.target.value));
            return {
                input: handler,
                change: handler,
            };
        },
        diff() {
            return this.max - this.min;
        },
        percentage() {
            return ((this.modelValue - this.min) / this.diff) * 100;
        },
    },
    watch: {
        percentage() {
            this.updateStyleRule();
        },
    },
    mounted() {
        this.styleElem = document.createElement('style');
        const content = `
        #jix-range-vue--${this.componentCounter}::-webkit-slider-runnable-track {
            background-size: 0% 100%;
        }
        `;
        this.styleElem.appendChild(document.createTextNode(content));
        document.head.appendChild(this.styleElem);

        for (const style of document.styleSheets) {
            if (style.ownerNode === this.styleElem) {
                const rule = style.cssRules[0];
                if (rule) {
                    this.style = rule.style;
                    this.updateStyleRule();
                }
                break;
            }
        }
    },
    unmounted() {
        if (this.styleElem) {
            this.styleElem.remove();
            this.styleElem = null;
        }
        this.style = null;
    },
    methods: {
        updateStyleRule() {
            if (this.style) {
                this.style.backgroundSize = `${this.percentage}% 100%`;
            }
        },
    },
};
</script>
